import React from 'react';

import { TableTr, TableTd } from 'design/table';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { CardPayment } from 'types/state';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { TextComponent } from 'design/text/textComponents';

type Props = {
  payment: CardPayment;
  active: boolean;
  onClick(id: number): void;
};

export const CardPaymentsTableRow = (props: Props) => {
  const { payment, active, onClick } = props;

  const intl = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(payment.id);
  }, [onClick, payment.id]);

  const updatedAtText = payment.updatedAt
    ? intl.shared.dates.calendarDateWithTime(new Date(payment.updatedAt))
    : '-';

  const statusText = payment.status
    ? intl.shared.cardPaymentStatusValue(payment.status)
    : '-';

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={`${payment.id}`} />
      <TableTd text={payment.userProfile.company} />
      <TableTd text={normalizeProfileLike(payment.userProfile).toFullName()} />
      <TableTd
        text={
          payment.creditedTransaction
            ? intl.shared.paymentTransactionText(payment.creditedTransaction)
            : '-'
        }
      />
      <TableTd
        text={
          payment.status !== 'REVERSED' && payment.status !== 'DECLINED'
            ? intl.shared.paymentTransactionText(payment.recievedTransaction)
            : '-'
        }
      />
      <TableTd
        text={
          <TextComponent
            color={
              payment.status === 'DECLINED'
                ? 'critical'
                : payment.status === 'REVERSED'
                ? 'secondary'
                : 'primary'
            }
            size="s"
          >
            {statusText}
          </TextComponent>
        }
      />
      <TableTd text={updatedAtText} />
    </TableTr>
  );
};
